import { assign } from "xstate";

import { IContext, IEvent } from "./types";

export const selectPaymentType = assign<IContext, IEvent>({
  paymentType: (_ctx, event) =>
    (event.type === "SELECT_PAYMENT_TYPE" && event.paymentType) || null,
});

export const setBackupPaymentData = assign<IContext, IEvent>({
  figmaPlanId: (_ctx, event) =>
    (event.type === "SET_BACKUP_PAYMENT_DATA" && event.figmaPlanId) || null,
  planQuantity: (_ctx, event) =>
    (event.type === "SET_BACKUP_PAYMENT_DATA" && event.planQuantity) || 50,
  isFigmaBackup: (_ctx, event) =>
    (event.type === "SET_BACKUP_PAYMENT_DATA" && event.isFigmaBackup) || false,
});

export const openPaymentSuccessfulModal = assign<IContext, IEvent>({
  modalIsOpened: () => true,
});

export const closePaymentSuccessfulModal = assign<IContext, IEvent>({
  modalIsOpened: () => false,
  isFigmaBackup: () => false,
});

export const setUserEmail = assign<IContext, IEvent>({
  userEmail: (_ctx, event) =>
    (event.type === "SET_USER_EMAIL" && event.email) || null,
});

export const setHandleCheckoutResult = assign<IContext, IEvent>({
  hostedPageId: (_ctx, event) =>
    (event.type === "done.invoke.handleCheckout" && event.data.hostedPageId) ||
    null,
  newUser: (_ctx, event) =>
    event.type === "done.invoke.handleCheckout" ? event.data.isNewUser : null,
});
